module.exports = __webpack_public_path__ + "static/media/exuk-vinyl-signage.67e9d56b.png";